"use strict";
var defineProperty = require('./_defineProperty');
function baseAssignValue(object, key, value) {
    if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
            'configurable': true,
            'enumerable': true,
            'value': value,
            'writable': true
        });
    }
    else {
        object[key] = value;
    }
}
module.exports = baseAssignValue;
//# sourceMappingURL=_baseAssignValue.js.map